import { call, put, select } from 'redux-saga/effects';
import apiUrl from 'common/api-url';
import * as api from 'reduxStore/apiService';
import { trackServicesCreatedFromTemplate } from 'components/menu/tracking/menuSegmentTracking';

import { MenuGroupsPayload } from './types';

import {
  getMenuGroupTemplateSuccess,
  getMenuGroupTemplateFailure,
  setMenuGroupServices,
  setMenuGroupServicesSuccess,
  setMenuGroupServicesFailure,
} from './actions';

export function* requestMenuGroupTemplateRequested() {
  try {
    const payload: MenuGroupsPayload = yield call(api.get, apiUrl('MENU_GROUP_TEMPLATE'));

    yield put(getMenuGroupTemplateSuccess(payload.menuGroups));
  } catch (err) {
    yield put(getMenuGroupTemplateFailure());
  }
}

/**
 * The templates as they arrived from the API, keyed by service id. The partner
 * can rename a template service before submitting it, so this is what tells the
 * renamed service apart from the template it came from (THY-2397).
 */
export const selectTemplateServiceNames = (state: any): Record<number, string> => {
  const groupTypesList =
    (state.menu && state.menu.menuTemplates && state.menu.menuTemplates.groupTypesList) || [];
  const names: Record<number, string> = {};

  groupTypesList.forEach((group) => {
    (group?.services || []).forEach((service) => {
      if (service?.serviceId != null) {
        names[service.serviceId] = service.name;
      }
    });
  });

  return names;
};

export function* setMenuServicesRequested(action: ReturnType<typeof setMenuGroupServices>) {
  try {
    const { menuGroups, targetMenuGroupId, targetMenuGroupName } = action.payload;
    const templateServiceNames = yield select(selectTemplateServiceNames);
    yield call(api.post, apiUrl('CREATE_SERVICES_FROM_TEMPLATE'), {
      menuGroups,
      targetMenuGroupId,
    });

    yield put(setMenuGroupServicesSuccess());

    // Reported here rather than from the modal so a server-rejected bulk create
    // is never counted as completed. One event per service (THY-2347).
    trackServicesCreatedFromTemplate({
      menuGroups,
      targetMenuGroupId,
      targetMenuGroupName,
      templateServiceNames,
    });
  } catch (err) {
    yield put(setMenuGroupServicesFailure());
  }
}
